<template>
    <div class="wl-container">
        <NewComments :messageType="messageType" :siteId="siteId"></NewComments>
        <div class="wl-content-container content-with-comments">
            <!--  tabs-->
            <div class="tab-row">
                <ul class="tab-cls" v-if="adminTabs.length>0 && activeTab">
                    <li :class="activeTab.key === item.key ? 'active' : ''" @click="activeChange(item)" v-for="item in adminTabs" :key="item.key">
                        {{ item.name }}
                    </li>
                </ul>
                <div class="btn flex item-center">
                    <span :class="['clear-filter', clearFilterActive ? 'clear-filter-active' : '']" @click="clearAll">
                        <img src="@/assets/img/icon-screen.svg" class="table-setting-icon" />
                        {{ $t('clear_filter') }}
                    </span>
                </div>
            </div>
            <div class="main-content" v-if="activeTab">
                <component :is="activeTab.comName" :clearFilterActive.sync="clearFilterActive" ref="activeTab"></component>
            </div>
        </div>
        
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { userPermission } from '@/mixins/userPermission.js'
import ContractManagement from './ContractManagement'
import FeeManagement from './FeeManagement'
import VatManagement from './VatManagement'
import InvoicesManagement from './InvoicesManagement'
import { dateFormat } from '@/utils'
import API from '@/api'
import NewComments from '@/components/common/NewComments.vue'


export default {
    name: 'index',
    components: {
        ContractManagement,
        FeeManagement,
        VatManagement,
        InvoicesManagement,
        NewComments

    },
    computed: {
        ...mapGetters('common', {
            getUser: 'getUser',
            getSite: 'getSite',
            getEntityIds: 'getEntityIds'
        }),
        isKpmgUser() {
            return this.getUser.userType === '1'
        },
        adminTabs(){
            return this.adminAllTabs.filter(tab=>{
                if(tab.key!=='adminVatInformation'){
                    return tab.checked === true
                }else{
                    return tab.checked === true && this.getSite.showVatInformation === true;
                }
            })
        },
        siteId(){
            return this.getSite.siteId
        },
        messageType(){
            if(!this.activeTab) return '';
            let messageType = '';
            switch(this.activeTab.key){
                case 'adminInvoice':
                    messageType = '6';
                break;
                case 'adminVatInformation':
                    messageType = '7';
                break;
                default:
                    messageType = '';
                break;
            }
            return messageType
        }
    },
    mixins: [userPermission],
    data() {
        return {
            activeTab:null,
            adminAllTabs:[
                {
                    name:this.$t('admin.invoices'),
                    key:'adminInvoice',
                    comName:InvoicesManagement,
                    checked:false
                },
                {
                    name:this.$t('admin.vat'),
                    key:'adminVatInformation',
                    comName:VatManagement,
                    checked:false
                },
                {
                    name:this.$t('admin.contract'),
                    key:'adminContract',
                    comName:ContractManagement,
                    checked:false
                },
                {
                    name:this.$t('admin.fee'),
                    key:'adminFeeAgreement',
                    comName:FeeManagement,
                    checked:false
                }, 
            ],
            clearFilterActive:false,
            dataDeadline: null
        }
    },
    async mounted() {
        this.dataDeadline = dateFormat(new Date(new Date() - 3600 * 1000 * 24 * 2), 'yyyy-MM-dd')
        await this.getAdminTabs();
        this.activeTab = this.adminTabs&&this.adminTabs.length>0?this.adminTabs[0]:null;
        this.activeChange(this.activeTab)
    },
    methods: {
        // admin tabs 全选/全不选
        checkedAdminTab(isChecked) {
            this.adminAllTabs.forEach((item) => (item.checked = isChecked))
        },
        async getAdminTabs(){
            //kpmg用户拥有所有的tab
            //client权限控制
            if(this.isKpmgUser){
                this.checkedAdminTab(true);
            }else{
                const {code,data} =  await API.clientRoles.queryUserAdminPermission({
                    siteId: this.getSite.siteId
                })
                if(code === '1'){
                    if(!data) return;
                    const { contractStatus,feeAgreementStatus,invoiceStatus,vatInformationStatus } = data;
                    const userAdminStatus = {
                        adminContract:contractStatus === 'Y',
                        adminFeeAgreement:feeAgreementStatus === 'Y',
                        adminVatInformation:vatInformationStatus === 'Y',
                        adminInvoice:invoiceStatus === 'Y'
                    }
                    this.adminAllTabs.forEach(adminTab=>{
                        adminTab.checked = userAdminStatus[adminTab.key]
                    })

                }
            }
            
        },
        activeChange(val) {
            this.activeTab = val
        },
        clearAll(){
            this.$refs.activeTab.clearAll()
        }
    }
}
</script>

<style scoped>
.wl-container {
    height: 100%;
    background: #eff1f5;
    padding: 22px;
}

.wl-content-container {
    background: #fff;
    height: 100%;
    padding: 10px 22px;
    border-radius: 8px;
}
.tab-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    /* border-bottom: 1PX solid #e3e4e6; */
}
.clear-filter {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    font-size: 12PX;
}

.main-content{
    height: calc(100% - 46px);
    position: relative;
}

.clear-filter img {
    margin-right: 5px;
}
.tab-cls {
    display: flex;
    list-style: none;
    justify-content: flex-start;
    align-items: flex-start;
    height: 38PX;
}
.tab-cls li {
    margin-right: 10px;
    background-color: #ccced2;
    height: 28PX;
    line-height: 28PX;
    border-radius: 14PX;
    color: #fff;
    font-size: 14PX;
    padding: 0 30px;
    cursor: pointer;
}
.tab-cls li.active {
    background-color: #3879eb;
}

</style>
